import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../services/auth";

import "../styles/auth.css";

export default function Register() {

    const navigate = useNavigate();

    const [form, setForm] = useState({

        full_name: "",
        email: "",
        phone: "",
        password: "",
        confirm: ""

    });

    const change = (e) => {

        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

    };

    const submit = async (e) => {

        e.preventDefault();

        if (form.password !== form.confirm) {

            alert("Passwords do not match");
            return;

        }

        if (!form.email.trim() && !form.phone.trim()) {

            alert("Please provide an email address or a phone number.");
            return;

        }

        try {

            await registerUser({

                full_name: form.full_name,
                email: form.email,
                phone: form.phone,
                password: form.password

            });

            alert("Registration Successful");

            navigate("/login");

        }
        catch (err) {

            alert(err.response?.data?.message || "Registration Failed");

        }

    };

    return (

        <div className="authContainer">

            <div className="authCard">

                <h1>CercaTrova</h1>

                <p>Solar Monitoring Platform</p>

                <form onSubmit={submit}>

                    <input
                        name="full_name"
                        placeholder="Full Name"
                        onChange={change}
                    />

                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        onChange={change}
                    />

                    <input
                        name="phone"
                        type="tel"
                        placeholder="Phone Number"
                        onChange={change}
                    />

                    <input
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={change}
                    />

                    <input
                        name="confirm"
                        type="password"
                        placeholder="Confirm Password"
                        onChange={change}
                    />

                    <button>

                        Create Account

                    </button>

                </form>

                <p>

                    Already have an account?

                    <Link to="/login">

                        Login

                    </Link>

                </p>

            </div>

        </div>

    );

}